import { currencyColumnDefinition, defaultColumnDefinition } from '../../shared/columnDefinitions';
import { NumberCellEditor } from '../../shared/columnDefinitions/cellRenderers';

const parseAccountAmount = value => {
  if (value === '' || value === null || typeof value === 'undefined') {
    return 0;
  }
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const getColumnDefinitions = ({ isInEditMode, updateRow }) => {
  const onRowValueChanged = ({ data }) => {
    updateRow(data);
  };

  return [
    {
      ...defaultColumnDefinition,
      headerName: 'State',
      field: 'stateDescription',
    },
    {
      ...defaultColumnDefinition,
      ...currencyColumnDefinition,
      headerName: 'Amounts',
      field: 'accountAmount',
      width: 150,
      maxWidth: 150,
      editable: isInEditMode,
      cellEditor: NumberCellEditor,
      cellEditorParams: {
        formatValue: parseAccountAmount,
      },
      valueSetter: ({ data, newValue }) => {
        data.accountAmount = parseAccountAmount(newValue);
        return true;
      },
      onCellValueChanged: onRowValueChanged,
    },
  ];
};

export default getColumnDefinitions;
